import { useQuery } from 'react-query';
import { getDataOption } from 'src/apis/Commons/commons';
import { TRequestOption } from 'src/types/Commons/option.model';

export function useFetchDataOptions(param: TRequestOption, option?: any) {
  return useQuery(['fetchDataOption', param], async () => getDataOption(param), option);
}
